<template>
  <div>
    <aru-auto-form
      :disabled="disabled"
      v-if="!!currentFormConfig"
      v-model="wizardStepModel"
      :validate-before-submit="validateBeforeSubmit"
      :title="title"
      :key="step"
      :form-configuration="currentFormConfig"
      :submit-text="submitText"
      dismiss-button
      :dismiss-text="$t('Atrás')"
      show-header-actions
      :saving-data="savingData"
      @dismiss="wizardPrevStep"
      @submit="wizardStepSubmit"
      @validationErrors="wizardErrors"
    ></aru-auto-form>
  </div>
</template>

<script>
import AruAutoForm from '@/components/commons/form/AruAutoForm.vue';

export default {
  components: {
    AruAutoForm,
  },
  props: {
    validateBeforeSubmit: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
    },
    title: {
      type: String,
    },
    step: {
      type: Number,
      default: 2,
    },
    disabled: {
      type: Boolean,
    },
    model: {
      type: Object,
      default() {
        return {};
      },
    },
    savingData: {
      type: Boolean,
    },
    submitText: {
      type: String,
      default() {
        return this.$t('Siguiente');
      },
    },
  },
  data() {
    return {
      wizardStepModel: this.model,
    };
  },
  mounted() {},
  computed: {
    currentFormConfig() {
      if (this.config.hasOwnProperty('formWizard' + this.step)) {
        return this.config['formWizard' + this.step];
      } else {
        return null;
      }
    },
  },
  methods: {
    wizardStepSubmit(data) {
      this.$emit('wizardStepSubmit', data);
    },
    wizardPrevStep(data) {
      this.$emit('wizardPrevStep', this.wizardStepModel);
    },
    wizardErrors(err) {},
  },
};
</script>

<style></style>
